import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    console.error('Error capturado por ErrorBoundary:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }
  handleGoHome = () => {
    window.location.href = '/';
  };
  render() {
    const { t } = this.props;
    if (this.state.hasError) {
      return (
        <div
          style={{
            background:
              'linear-gradient(to bottom, #FFFFFF 0%, #FFFFFF 50%, rgb(255, 59, 59, .25) 100%)',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#333',
            fontFamily: 'Arial, sans-serif',
            textAlign: 'center',
            gap: 5,
          }}
        >
          <p
            style={{
              fontSize: '2em',
              fontWeight: 300,
              color: 'var(--input-list)',
              margin: '0 0 10px 0',
            }}
          >
            {t('error.ups')}
            <br /> {t('error.mal')}
          </p>
          <span
            style={{
              fontSize: '1.25em',
              fontWeight: 300,
              color: 'var(--input-list)',
              maxWidth: '30%',
              lineHeight: '1.5',
            }}
          >
            {t('error.texto')} {}
          </span>
          <button
            onClick={this.handleGoHome}
            style={{
              marginTop: '30px',
              padding: '.5rem 1rem',
              fontSize: '1.1em',
              backgroundColor: '#000000',
              border: '1px solid var(--link-color)',
              color: 'white',
              borderRadius: '20px',
              fontWeight: 300,
              cursor: 'pointer',
              transition: 'background-color 0.5s ease, transform 0.2s ease',
            }}
            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#4d4d4d')}
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#000000')}
          >
            {t('error.boton')} {}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
export default withTranslation()(ErrorBoundary);
